/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestAudioApps from "views/articles/BestAudioApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const Article = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestAudioApps["ar"]

  return (
    <InstantArticle {...article}>
      <div dir="rtl" style={{ textAlign: "justify" }}>
        <p>
          هل تبحث عن أفضل تطبيقات قص وتحرير الصوت لجهاز iPhone أو iPad الخاص بك؟
          في هذا المقال، قمنا بتجميع قائمة تضم أفضل 4 تطبيقات، كل تطبيق يتميز
          بميزات فريدة من نوعها لتلبية جميع احتياجاتك في تحرير الصوت. بدءًا من
          تحويل m4a إلى mp3، و youtube إلى wav، و mp3 إلى wave، هذه التطبيقات
          ستغطي كل احتياجاتك. لذا، دعونا نغوص في هذه القائمة ونجد التطبيق
          المثالي لك!
        </p>
        <h2>Lexis Audio Editor</h2>
        <p>
          محرر الصوت ليكسيس هو تطبيق متعدد الاستخدامات لقص ودمج ملفات الصوت
          لأجهزة iOS. توفر هذا الأداة القوية واجهة سهلة الاستخدام لقص وضغط ودمج
          ملفات الصوت، مما يجعله مثاليًا للمبتدئين والمستخدمين المتقدمين على حد
          سواء.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1259401721)} />
        </div>
        <h2>Hokusai Audio Editor</h2>
        <p>
          محرر الصوت هوكوساي هو تطبيق بديهي لتحرير وقص ملفات الصوت أثناء التنقل.
          مع ميزة إزالة صوت المغني، يمكنك إنشاء مقطوعات الكاريوكي من أغانيك
          المفضلة أو إزالة الضوضاء الغير مرغوبة من تسجيلاتك.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 432079746)} />
        </div>
        <h2>The Audio Converter</h2>
        <p>
          يتخصص هذا التطبيق في تحويل m4a إلى mp3 او الفيديو الى صوت وهو أداة
          أساسية لأولئك الذين يحتاجون إلى التبديل بين تنسيقات الصوت. توفر واجهة
          المستخدم السهلة الاستخدام وعملية التحويل السريعة جعلته من المفضل بين
          مستخدمي iPhone و iPad الذين يتعاملون مع ملفات الصوت المختلفة.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 889643660)} />
        </div>
        <h2>Audio Trimmer - Trim Audio</h2>
        <p>
          يتيح لك هذا التطبيق قص ملفات الصوت بسهولة. يتميز بواجهة بديهية وسهلة
          الاستخدام تجعل عملية تحرير الصوت أمرًا سهلًا وممتعًا.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1602845668)} />
        </div>
        <br />

        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              هل لديك تطبيقات مفضلة لتحرير وقص الصوت على iPhone و iPad؟ يمكنك
              مشاركة التطبيقات المفضلة لديك من خلال{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  صفحة النشر
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default Article
